<template>
    <div class="contents">
      <BtnSearch :searchGoods="searchGoods" :middle="false"/>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="load()">
      <ListImg :list="list" @ClickItem="GoCategoryList"/>
      </van-list>
    </div>
</template>

<script>
import BtnSearch from "@/components/BtnSearch.vue";
import ListImg from "@/components/ListImg.vue";
import { GetCategory } from "../../apis/https.js";
import { List } from "vant";
import Vue from "vue";
Vue.use(List);
export default {
  components: {
    ListImg,
    BtnSearch
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: true
    };
  },
  created() {
    this.$toast.loading({
      duration: 0,
      loadingType: "spinner",
      message: "加载中"
    });
    this.getList();
  },
  methods: {
    getList() {
      GetCategory().then(res => {
        if (res.code == "1") {
          this.$toast.clear();
          let arr = res.data.list.all;
          let result = new Array();
          for (let i in arr) {
            if (arr[i].image != null) {
              result.push({
                CategoryId: arr[i].category_id,
                Img: arr[i].image.file_path
              });
            }
          }
          this.list = result;
        }
      }).catch(e=>{});
    },
    GoCategoryList(id) {
      this.$router.push({
        name: "goodlist", // 路由的名称
        query: {
          id: id
        }
      });
    },
    searchGoods(){
      this.$router.push("/pages/search/index");
    },
    load(){
      this.loading = false;
    }
  }
};
</script>
<style lang="less" scoped>
.contents{
  // margin-bottom: 50px;
}
</style>
<style>
@media (device-height: 812px) and (device-width: 375px){
  .contents{
    margin-bottom:  0px !important;
  }
  .frame{
    padding-bottom:2.133333rem !important;
  }
}
</style>
